import { ClassList } from "./ClassList";
import { LayoutEntity } from "./Definitions";
import { MediaSpecific, mediaSpecificClass } from "./Media";
import css from "./Styles/height.module.scss";

export const enum Height
{
    H240,
    H320,
    H360,
    H364,
    H380,
    H500,
    H600,
    H720,
    W100P,
}

const heightClassMap: Record<Height, string> = {
    [Height.H240]: "240",
    [Height.H320]: "320",
    [Height.H360]: "360",
    [Height.H364]: "364",
    [Height.H380]: "380",
    [Height.H500]: "500",
    [Height.H600]: "600",
    [Height.H720]: "720",
    [Height.W100P]: "100p",
};

export type LayoutHeight = LayoutEntity<Height, "height">;
export type LayoutMaxHeight = LayoutEntity<Height, "maxHeight">;

export const heightClass = (height?: Height | MediaSpecific<Height | LayoutHeight>): ClassList => mediaSpecificClass(height, "height", (height, suffix) => css[`h-${heightClassMap[height]}${suffix}`]);
export const maxHeightClass = (maxHeight?: Height | MediaSpecific<Height | LayoutMaxHeight>): ClassList => mediaSpecificClass(maxHeight, "maxHeight", (maxHeight, suffix) => css[`mxh-${heightClassMap[maxHeight]}${suffix}`]);
